import Vue from "vue";
import VueRouter from "vue-router";
import {NProgress} from "./nprogress.js";

import Home from "./views/Home.vue";
import Privacy from "./views/Privacy.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import UserValidation from "./views/UserValidation.vue";
import PasswordReset from "./views/PasswordReset.vue";

import Dashboard from "./views/Dashboard.vue";
import UserProfile from "./views/UserProfile.vue";

import Question from "./views/Question.vue";
import QuestionEditThemes from "./views/QuestionEditThemes.vue";
import QuestionEditDetails from "./views/QuestionEditDetails.vue";
import QuestionEditDocuments from "./views/QuestionEditDocuments.vue";

import Reference from "./views/Reference.vue";
import ReferenceEdit from "./views/ReferenceEdit.vue";

Vue.use(VueRouter);

const routes = [
	// Home – Registration 1 – create user account
	{
		path: "/",
		name: "home",
		component: Home
	},

	// Registration 2 – email validation
	{
		path: "/user/:userID/validate/:validationToken",
		name: "UserValidation",
		component: UserValidation
	},

	// Registration 3 - complete user profile
	{
		path: "/register",
		name: "register",
		component: Register
	},

	// Password reset
	{
		path: "/password-reset/:passwordResetToken?",
		name: "passwordReset",
		component: PasswordReset
	},

	// Privacy Terms
	{
		path: "/privacy",
		name: "privacy",
		component: Privacy
	},

	// Login page
	{
		path: "/login",
		name: "login",
		component: Login
	},

	// User Dashboard – questions lists
	{
		path: "/dashboard",
		name: "dashboard",
		component: Dashboard,
		meta: {
			authenticated: true
		}
	},

	// User Profile (optional email update confirmation)
	{
		path: "/user/:userProfileID/profile*",
		name: "userProfile",
		component: UserProfile,
		props: true,
		meta: {
			authenticated: true
		}
	},

	// display question
	{
		path: "/question/:questionID",
		name: "question",
		component: Question,
		props: true,
		meta: {
			authenticated: true
		}
	},

	// view Reference
	{
		path: "/question/:questionID/reference/:refID",
		name: "reference",
		component: Reference,
		props: true,
		meta: {
			authenticated: true
		}
	},

	// edit Reference
	{
		path: "/question/:questionID/reference/:refID/edit",
		name: "referenceEdit",
		component: ReferenceEdit,
		props: true,
		meta: {
			authenticated: true
		}
	},

	// edit/new question : themes
	{
		path: "/edit-question-themes/:questionID",
		name: "questionEditThemes",
		component: QuestionEditThemes,
		props: true,
		meta: {
			authenticated: true
		}
	},

	// edit/new question : details
	{
		path: "/edit-question-details/:questionID",
		name: "questionEditDetails",
		component: QuestionEditDetails,
		props: true,
		meta: {
			authenticated: true
		}
	},

	// edit/new question : documents
	{
		path: "/edit-question-documents/:questionID",
		name: "questionEditDocuments",
		component: QuestionEditDocuments,
		props: true,
		meta: {
			authenticated: true
		}
	}

	// TODO: code splitting?
	// {
	// 	path: "/about",
	// 	name: "about",
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () =>
	// 		import(/* webpackChunkName: "about" */ "../views/About.vue")
	// }
];

// Router config
const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

// Route gards: loader
router.beforeResolve((to, from, next) => {
	// If this isn't an initial page load.
	if (to.name) {
		// Start the route progress bar.
		NProgress.start();
	}
	next();
});

router.afterEach((to, from) => {
	// Complete the animation of the route progress bar.
	NProgress.done();
});

export default router;
